import NetMsgDataToBuffer from "../../../framework/net/net_msgdata_to_buffer";
import * as TexasProto from "./proto/proto_texasholdem_game";
import { TexasRoom } from "./proto/proto_texasholdem_room";


export class NetMsgTexasholdem extends NetMsgDataToBuffer {
    //发送命令名|发送结构体|收包命令|收包结构体|协议类型:1为登录服，2为麻将游戏服，3为Skynet扑克服
    //登陆或重连发送的数据
    static GameInfo: any[] = [null, null, "Game.GameInfo",TexasProto.Texas.GameInfo, 3];
    //玩家操作
    static PlayerAction:any[] = ['Game.PlayerAction', TexasProto.Texas.PlayerAction, "Game.ActionReply", TexasProto.Texas.ActionReply, 3];
    //广播玩家动作
    static ActionBroadcast:any[] = [null, null, "Game.ActionBroadcast", TexasProto.Texas.ActionBroadcast, 3];

    //下个玩家可做的动作
    static NextPlayerAction:any[] = [null, null, "Game.NextPlayerAction", TexasProto.Texas.NextPlayerAction, 3];
    //座位相关
    static SeatAction:any[] = ['Game.SeatAction', TexasProto.Texas.SeatAction, "Game.SeatActionReply", TexasProto.Texas.SeatActionReply, 3];
    //座位相关广播
    static SeatActionBroadcast:any[] = [null, null, "Game.SeatActionBroadcast", TexasProto.Texas.SeatActionBroadcast, 3];
    //游戏结算消息
    static GameSettlement:any[] = [null, null, "Game.GameSettlement", TexasProto.Texas.GameSettlement, 3];
    //游戏中补充筹码
    static Recharge:any[] = ['Game.Recharge',TexasProto.Texas.Recharge,'Game.RechargeReply',TexasProto.Texas.RechargeReply,3];

    static Error:any[] = [null, null, "Game.Error", TexasProto.Texas.Error, 3];

    static NextAction:any[] = [null, null, "Game.NextAction", TexasProto.Texas.NextAction, 3];

    static EnterBroadcast:any[] = [null, null, "Room.EnterBroadcast", TexasRoom.EnterBroadcast, 3];

    static NeedRecharge:any[] = [null, null, "Game.NeedRecharge", TexasProto.Texas.NeedRecharge, 3];

    static GameStart:any[] = [null, null, "Game.GameStart", TexasProto.Texas.GameStart, 3];

    static CoinStatus:any[] = [null, null, "Game.CoinStatus", TexasProto.Texas.CoinStatus, 3];

    static UserMsg:any[] = [null, null, "Game.UserMsg", TexasProto.Texas.UserMsg, 3];

    static LeaveBroadcast: any[] = [null, null, "Room.LeaveBroadcast", TexasRoom.LeaveBroadcast, 3]

    static KickPlayerBroadcast: any[] = [null, null, "Room.KickPlayerBroadcast", TexasRoom.KickPlayerBroadcast, 3]
}